import { render, staticRenderFns } from "./CalculateSalaryProcessLevyLockDetail.vue?vue&type=template&id=07fe9c72&"
import script from "./CalculateSalaryProcessLevyLockDetail.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLevyLockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports